import {
  TKV2_ORDER_DEPRECIATION_SETTINGS_API,
  Tkv2DepreciationSettings,
} from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  PutTkv2OrderDepreciationSettingsAPIError,
  PutTkv2OrderDepreciationSettingsAPIVariables,
  fetchPutTkv2OrderDepreciationSettingsAPI,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_DEPRECIATION_SETTINGS_API.PUT;

export const usePutTkv2OrderDepreciationSettingsAPI = (
  options?: Omit<
    UseMutationOptions<
      Tkv2DepreciationSettings,
      PutTkv2OrderDepreciationSettingsAPIError,
      PutTkv2OrderDepreciationSettingsAPIVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<
    Tkv2DepreciationSettings,
    PutTkv2OrderDepreciationSettingsAPIError,
    PutTkv2OrderDepreciationSettingsAPIVariables
  >({
    mutationFn: (variables: PutTkv2OrderDepreciationSettingsAPIVariables) =>
      fetchPutTkv2OrderDepreciationSettingsAPI({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
